export default "/institutions/brand-mastercard.svg";